import { ExportRow } from '@portal/shared/types/export.types';
import { BaseStationItemListResponseDto } from '../base-stations-listing-page.types';

export const mapBaseStationToExport = (baseStation: BaseStationItemListResponseDto): ExportRow => ({
  deviceId: { title: 'Device ID', value: baseStation.deviceId },
  model: { title: 'Model', value: baseStation.model },
  provisioningStatus: { title: 'Provisioning Status', value: baseStation.provisioningStatus ?? '' },
  macId: { title: 'MAC ID', value: baseStation.macId ?? '' },
  backhaulConnectionConfigured: {
    title: 'Backhaul Configuration',
    value: baseStation.backhaulConnectionConfigured ? 'Yes' : 'No'
  },
  ranConfigured: { title: 'RAN Configuration', value: baseStation.ranConfigured ? 'Yes' : 'No' },
  provisioningDateTime: { title: 'Provisioning Date Time', value: baseStation.provisioningDateTime ?? '' }
});
